<template>
  <div class="menu-group">
    <div
      v-for="(group,index) in $store.state.groups.data"
      :key="index">
      <Group
        :group="group"
        class="group-component" />
    </div>
  </div>
</template>

<script>
import Group from '@/components/modules/DailyReport/MenuGroupSelect'

export default {
  components: {
    Group
  }
}
</script>

<style scoped>
.menu-group {
  margin: 5px 0 0 0;
}
.group-component {
  margin: 0px 0 1px 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/DailyReport/MenuGroup.vue